









































import { Vue, Component } from 'vue-property-decorator';
import { Icon, Toast } from 'vant';
import { getDetail, share, nextLastId } from '../api';
import { isWeiXin } from '@/common/ts/common';

Vue.use(Icon);
@Component
export default class Detail extends Vue {
  detailData: any = {};
  ids: any = {};
  get detail() {
    return this.$route.query;
  }
  async created() {
    const res = await getDetail(this.detail.id as string);
    this.detailData = res.data;
    const ids = await nextLastId(this.detail.id, this.detail.type);
    this.ids = ids.data;
    share(this);
  }
  updateZan(data: string) {
    this.detailData.votes = data;
    // this.getData();
    // this.$emit('updateZan');
  }
  backHome() {
    this.$router.push({
      path: 'home',
    });
  }
  changeDetail(type: string) {
    if (type === 'next') {
      if (String(this.ids.nextId) !== '0') {
        location.href = `${location.origin}${location.pathname}?id=${this.ids.nextId}&type=${this.detail.type}`;
      } else {
        Toast('这已经是最后一条了~');
      }
    } else if (type === 'last') {
      if (String(this.ids.lastId) !== '0') {
        location.href = `${location.origin}${location.pathname}?id=${this.ids.lastId}&type=${this.detail.type}`;
      } else {
        Toast('这是第一条哦，点击下一条查看更多~');
      }
    }
  }
}
